import useUserState from "ui/adapter/state/useUserState";
import { RoleType } from "common/models/role/Role";
import useGetProgram from "features/programs/hooks/useGetProgram";
import useGetPartner from "features/partners/hooks/useGetPartner";

export default function useSelectedOrganizationAddress(): string | undefined {
    const { selectedRole } = useUserState();

    const { data: program } = useGetProgram({ address: selectedRole?.program?.address });
    const { data: partner } = useGetPartner({ address: selectedRole?.partner?.address });

    switch (selectedRole?.roleType) {
        case RoleType.ORGANIZATION_OWNER:
        case RoleType.OPERATION_MANAGER:
        case RoleType.CUSTOMER_SERVICE:
            return selectedRole.resourceAddress;
        case RoleType.PARTNER:
            return partner?.organizationAddress;
        case RoleType.PROGRAM_MANAGER:
            return program?.organizationAddress;
        default:
            return undefined;
    }
}
